// Shared display helpers for the admin inquiries list + detail. Inquiry numeric
// fields arrive as strings (Postgres NUMERIC) or null; these normalize them for
// rendering without leaking formatting details into the components.

const formatDollar = (n) => (n == null ? null : `$${Math.round(Number(n)).toLocaleString()}`);

// A null low/high pair means the area was below the pricing threshold and was
// flagged for a manual custom quote (see the pricing engine).
export const estimateText = (low, high) => {
  const lo = formatDollar(low);
  const hi = formatDollar(high);
  if (lo == null && hi == null) return 'Custom quote';
  return `${lo ?? '—'} – ${hi ?? '—'}`;
};

export const areaText = (sqMi) => (
  sqMi == null ? '—' : `${Number(sqMi).toLocaleString(undefined, { maximumFractionDigits: 1 })} sq mi`
);

export const populationText = (pop) => (pop == null ? '—' : Number(pop).toLocaleString());

export const formatDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
};

// MUI Chip colour per inquiry status, so the list + detail stay consistent.
export const STATUS_COLOR = {
  draft: 'default',
  submitted: 'info',
  emailed: 'success',
  email_failed: 'error',
};

export const statusColor = (status) => STATUS_COLOR[status] || 'default';

// Friendlier area-type label for display.
export const areaTypeLabel = (type) => {
  if (type === 'county') return 'County';
  if (type === 'city') return 'City';
  if (type === 'custom') return 'Custom upload';
  return type || '—';
};
